var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenggunakanTeknologiTerbarukan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104,
    height: 128.625,
    viewBox: "0 0 104 128.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.84,
    y1: 0.13,
    x2: 0.14,
    y2: 0.843,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0783d",
    stopOpacity: 0.482
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1292 -907)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(1292 907)",
    opacity: 0.266,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1305.549 678.672)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.53 280.328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.774,280.328a1.257,1.257,0,0,0-1.28,1.271v1.344H17.12a1.256,1.256,0,1,0,0,2.512h4.374v47.663H14.066a1.256,1.256,0,1,0,0,2.512h8.688a1.257,1.257,0,0,0,1.253-1.251V285.455h4.486a1.256,1.256,0,1,0,0-2.512H24.007V281.6a1.258,1.258,0,0,0-1.234-1.271Z",
    transform: "translate(43.489 -280.328)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,.262A1.26,1.26,0,0,0,6.763,1.535V2.881H2.27a1.258,1.258,0,1,0,0,2.516H6.763v49a1.257,1.257,0,0,0,1.253,1.253h8.7a1.258,1.258,0,1,0,0-2.516H9.279V5.4h4.383a1.258,1.258,0,1,0,0-2.516H9.279V1.535A1.257,1.257,0,0,0,8,.262Z",
    transform: "translate(1.275 -0.262)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.427.53c-4.777,0-5.507,5.255-6.682,9.749H6.426a5.9,5.9,0,0,0,0,11.793H26.788v.865a4.628,4.628,0,0,0,4.638,4.638H45.106a4.628,4.628,0,0,0,4.638-4.638v-.865H70.107a5.9,5.9,0,0,0,0-11.793H51.474C50.32,5.971,49.4.66,45.106.53Z",
    transform: "translate(-0.53 0.743)",
    fill: "#dad4d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.706,4.245C22.212,4.351,20.564,5.7,20.564,8.2c0,1.558-.767,1.558-1.526,1.558H9.847c-2.612,0-3.2,2.224-2.1,3.9H20.033a4.628,4.628,0,0,0,4.638-4.638V8.153h12.35a2.516,2.516,0,0,0-2.093-3.909Z",
    transform: "translate(24.543 14.661)",
    fill: "#a29292"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.324,287.551H40.461a4.757,4.757,0,0,1,4.768,4.768v32.8a4.757,4.757,0,0,1-4.768,4.768H9.324a4.757,4.757,0,0,1-4.768-4.768v-32.8A4.757,4.757,0,0,1,9.324,287.551Z",
    transform: "translate(12.565 -253.266)",
    fill: "#ffca3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.716,287.551v12.655a2.235,2.235,0,0,0,2.241,2.238h6.2a2.235,2.235,0,0,0,2.241-2.238V287.551Z",
    transform: "translate(24.403 -253.265)",
    fill: "#eae8e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.867,292.19a1.258,1.258,0,0,0,.121,2.512h4.552a1.256,1.256,0,1,0,0-2.512H6.867Z",
    transform: "translate(16.732 -235.886)",
    fill: "#ff9700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.914,293.358a1.256,1.256,0,0,0,0,2.512h9.1a1.256,1.256,0,1,0,0-2.512Z",
    transform: "translate(16.694 -231.51)",
    fill: "#ff9700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03,295.627a2.512,2.512,0,0,0-2.019,4.005H36.85a4.744,4.744,0,0,0,4.69-4.006Z",
    transform: "translate(16.177 -223.007)",
    fill: "#ff9700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.606,281.628a1.258,1.258,0,1,0,.13,2.512H20.028a1.256,1.256,0,0,0,0-2.512H8.736A1.211,1.211,0,0,0,8.606,281.628Z",
    transform: "translate(23.269 -275.463)",
    fill: "#eae8e8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenggunakanTeknologiTerbarukan);
export default __webpack_public_path__ + "static/media/menggunakan-teknologi-terbarukan.a1e35229530e280294155ef2595e734c.svg";
export { ForwardRef as ReactComponent };